const labels = {
  translations: {
    navbar: {
      home: "Home",
      language: "Language",
      tools: "Tools",
      social: "Social",
      articles: {
        title: "Articles",
        article_01: {
          title: "Create your video chat app with WebRTC (Portuguese only)",
          url: "https://dev.to/cesarpaulomp/crie-seu-app-de-video-chat-com-webrtc-1jea",
        },
        article_02: {
          title: "Create your private live server (Portuguese only)",
          url: "https://dev.to/cesarpaulomp/crie-seu-servidor-de-live-privado-part1-1g2g",
        },
        article_03: {
          title:
            "Generating Thumbnails with NODEJS, FFMPEG, AWS Lambda, and Terraform (Portuguese only)",
          url: "https://dev.to/cesarpaulomp/gerando-thumbnails-com-nodejs-ffmpeg-aws-lambda-e-terraform-2j00",
        },
      },
    },
    home: {
      highlights: "Highlights",
      carousel: {
        looper: {
          about: "Know more",
        },
      },
      about: {
        title: `About the studio`,
        description: `Unipig is an independent studio that aims to create fun games, on different devices, to play any time.`,
        what_is_a_unipig: `What is a "Unipig"?`,
        unipig_description: `It is a very powerful chimera created by the wizard Hugo, the Oldest.
        This creature has the power of "irresistibility", meaning no living individual is able to resist its charm.
        And that's why, fearing such power, Hugo left his creature here in the studio and fled to another universe.`,
      },
      contact: {
        title: `Need to talk to us?`,
      },
    },
    policy: {
      title: "Privacy Policy",
    },
    game: {
      blocknator: {
        policy: {
          description:
            "The services of the Blocknator application are provided by the individual with the following name: Paulo César Medeiros Porto, registered under CPF no. 09777223684, holder of the intellectual property rights over the software, website, applications, content, and other assets related to the Blocknator platform.",
          personal_data: "1. Personal data and other sensitive data",
          personal_data_desc_01:
            "We do not collect, store, or share personal data or other sensitive data belonging to those who use our application.",
          personal_data_desc_02:
            "We are not responsible for any damage caused to individuals who acquire illegal copies of the application.",
          policy_update: "2. Changes to this policy",
          policy_update_desc_01:
            "The present version of this Privacy Policy was last updated on: 11/04/2024.",
          policy_update_desc_02:
            "We reserve the right to modify, at any time, these rules, especially to adapt them to any changes made to our application, either by making new functionalities available, or by deleting or modifying existing ones.",
          contact: "3. How to contact us",
          contact_desc_01:
            "To clarify any doubts about this Privacy Policy, please contact us via email: ",
        },
      },
    },
  },
};
export default labels;
